import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import testSubjectJson from 'utils/set-values-config.json';
import {
  newCheckInAction,
  newNextAction,
  NEW_NEXT,
  SET_TEST_SUBJECT,
} from '../../actions/navigation';
import { useConfig } from '../../config/ConfigContext';
import ApplicationId from '../../components/ApplicationId';
import ContentWrapper from '../../components/ContentWrapper';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';
import Card from '../../components/Card';
import Footer from '../../components/Footer';
import Pagination from '../../components/Pagination';
import Tooltip from '../../components/Tooltip';
import Button from '../../components/Button';
import Transition from '../../components/Transition';
import Progress from '../../components/Progress';
import ListView from '../../components/ListView';
import Headline from '../../components/Headline';

import FullLogo from '../../assets/images/logo-full.svg';

const loanDetailsTestSubjects = testSubjectJson ? testSubjectJson.find((i) => i.pageName === 'loanDetails') : [];
const reviewDetailsTestSubjects = testSubjectJson ? testSubjectJson.find((i) => i.pageName === 'review') : [];

const image = null;

const Landing = (props) => {
  const config = useConfig();
  const { searchParams, params } = props;
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(null);
  const workflowType = get(params, 'workflowType') || 'text2apply';
  const key = searchParams.get('key');
  const test = searchParams.get('test');

  useEffect(() => {
    const { dispatch } = props;
    const to = searchParams.get('to');

    if (test) {
      const data = to
        ? {
          test,
          to,
        }
        : {
          test,
        };
      dispatch(newCheckInAction({
        key,
        workflowType,
        data,
      }));
    } else {
      const data = to
        ? {
          to,
        }
        : {
        };
      dispatch(newCheckInAction({
        key,
        workflowType,
        data,
      }));
    }
  }, []);

  useEffect(() => {
    const { fetch, navigate, checkinData } = props;

    if (checkinData.activity && checkinData.activity !== 'ApplyNow') {
      // extract route url from the api response
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(`${routeUrl}`);
    }

    if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(`${routeUrl}`);
    }
  }, [props.checkinData]);

  const handleNavigation = (e) => {
    e.preventDefault();
    const { dispatch } = props;

    if (props.checkinData && props.checkinData.data && props.checkinData.data.data && props.checkinData.data.data.applicant) {
      const { firstName, lastName } = props.checkinData.data.data.applicant;

      if (firstName && lastName && loanDetailsTestSubjects && loanDetailsTestSubjects.data) {
        const loanDetails = loanDetailsTestSubjects.data.find((i) => i.FirstName === firstName && i.LastName === lastName);
        const reviewDetails = reviewDetailsTestSubjects.data.find((i) => i.value.firstName === firstName && i.value.lastName === lastName);

        dispatch({
          type: SET_TEST_SUBJECT,
          payload: {
            loanDetails,
            reviewDetails,
          },
        });
      }
    }

    setIsProgressVisible(true);

    if (test) {
      dispatch(newNextAction({
        key,
        workflowType,
        data: {
          test,
        },
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
      }));
    } else {
      dispatch(newNextAction({
        key,
        workflowType,
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
      }));
    }
  };

  const renderHeader = () => (
    <ContentWrapper>
      <Headline
        image={FullLogo}
        header={(
          <>
            <span>
              Hi,
              {' '}
              {props.checkinData.data.data.applicant.firstName}
              !
            </span>
            Apply in
            {' '}
            <u>minutes</u>
            <br />
            Decisions in
            {' '}
            <u>seconds</u>
            .
            <br />
            Check your rate.
            <Tooltip>To check the rates you qualify for, LendingUSA does a soft credit pull that will not impact your credit score.</Tooltip>
          </>
        )}
      />
    </ContentWrapper>
  );

  const { checkinData: { activity, attributes, data } } = props;
  return (
    activity === 'ApplyNow'
      ? (
        <Transition className="transition-item wrapper landing">
          {renderHeader()}
          <Footer>
            <ApplicationId color="#FFF" id={get(attributes, 'entityId')} />
            <FormRow>
              <FormColumn>
                <Card title="Your Provider">
                  <ListView
                    data={[
                      <strong>{data.data && data.data.provider.name}</strong>,
                      data.data.provider.streetAddress,
                      `${data.data.provider.city}, ${data.data.provider.state} ${data.data.provider.zip}`,
                    ]}
                  />
                </Card>
                {
                image
                  && <img src={image} alt="imagetag" />
              }
              </FormColumn>
            </FormRow>
            <FormRow>
              <FormColumn>
                <Button
                  className="btn btn-primary arrow"
                  onClick={handleNavigation}
                  title="Apply Now"
                />
              </FormColumn>
            </FormRow>
            <FormRow>
              <FormColumn>
                <Pagination activeIndex={0} />
              </FormColumn>
            </FormRow>
          </Footer>
          {
          isProgressVisible && <Progress percent={uploadingPercentage} />
        }
        </Transition>
      )
      : ''
  );
};

Landing.propTypes = {
  dispatch: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  fetch: PropTypes.object.isRequired,
  checkinData: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(Landing);
